import { PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  ListFieldsKeys,
  ListFieldsRecordType,
  ListFieldsType,
} from "src/api/config";
import { DeleteItemRequestProps, GetSagaProps } from "src/modules/modules.type";
import { addUsers } from "src/modules/users/actions";
import {
  addItem,
  addItemSuccess,
  deleteItem,
  deleteItemSuccess,
  getItem,
  getItemIdle,
  getItems,
  getItemsIdle,
  getItemsSuccess,
  getItemSuccess,
  updateItem,
  updateItemSuccess,
} from "../actions";
import {
  AddItemRequestProps,
  getItemsRequest,
  UpdateItemRequestProps,
} from "../api";
import { addDefaultSaga } from "./addDefaultSaga";
import { deleteDefaultSaga } from "./deleteDefaultSaga";
import { getDefaultSaga } from "./getDefaultSaga";
import { updateDefaultSaga } from "./updateDefaultSaga";

export function* getSaga(action: PayloadAction<GetSagaProps>) {
  try {
    const payload = action.payload;
    let result: {
      items: ListFieldsRecordType[ListFieldsKeys];
      nextPage?: string;
    } | null = null;

    if (payload.all) {
      const { all, ...payload } = action.payload;

      let allItems: ListFieldsRecordType[ListFieldsKeys][] = [];
      let nextPage = null;

      do {
        // Выполни API-запрос и получи результат
        if (nextPage) {
          const resultAll: GetItemsResponse<ListFieldsKeys> = yield call(
            getItemsRequest,
            { ...payload, nextPage } // Передавай текущую страницу для загрузки данных
          );

          // Добавь текущие элементы к общему массиву
          allItems = [...allItems, ...resultAll.items];

          // Обнови `nextPage` из ответа, если он существует
          nextPage = resultAll.nextPage;
        }

        // Если `all` не установлен, выходим после первой загрузки
        if (!all) break;
      } while (nextPage); // Повторяй, пока существует следующая страница

      // Отправь все загруженные элементы в store после завершения всех запросов
      yield put(
        getItemSuccess({
          items: allItems,
          listName: payload.listName,
        })
      );
    } else {
      result = yield call(getDefaultSaga, payload);

      yield put(
        getItemsSuccess({
          ...result,
          listName: payload.listName,
          merge: payload.merge,
        })
      );
    }
    // @ts-ignore
    if (result.items.length > 0 && !payload.noUsersRequest) {
      let usersEmail: any = [];
      // @ts-ignore
      result.items.forEach((item: any) => {
        Object.keys(item).forEach((key) => {
          const field = item[key];
          if (field && !Array.isArray(field) && field.get_email) {
            if (field.get_email()) {
              usersEmail = [...usersEmail, field.get_email().toLowerCase()];
            }
          }
          if (
            field &&
            Array.isArray(field) &&
            field.length > 0 &&
            field[0].get_email
          ) {
            field.forEach((user) => {
              if (user.get_email()) {
                usersEmail = [...usersEmail, user.get_email().toLowerCase()];
              }
            });
          }
          if (
            (key === "AuthorEmail" ||
              key === "ResponsibleForRevisionEmail" ||
              key === "ResponsibleEmail") &&
            field &&
            (field.indexOf("@abinbevefes.com") !== -1 ||
              field.indexOf("@partnerabie.com") !== -1)
          ) {
            usersEmail = [...usersEmail, field.trim().toLowerCase()];
          }
        });
      });

      usersEmail = _.uniqWith(usersEmail, _.isEqual);
      if (usersEmail.length > 0) {
        yield put(addUsers(usersEmail));
      }
    }
  } catch (error) {
    console.log(error);
  }
}

interface GetItemsResponse<TListName extends ListFieldsKeys> {
  items: ListFieldsRecordType[TListName][];
  listName: TListName;
  nextPage: SP.ListItemCollectionPosition | null | undefined;
  count: number;
}

export function* itemSaga(action: PayloadAction<GetSagaProps>) {
  try {
    const payload = action.payload;

    let result: {
      items: ListFieldsRecordType[ListFieldsKeys];
      nextPage?: string;
    } | null = null;

    if (payload.all) {
      const { all, ...payload } = action.payload;

      let allItems: ListFieldsRecordType[ListFieldsKeys][] = [];
      let nextPage = null;

      do {
        // Выполни API-запрос и получи результат
        if (nextPage) {
          const resultAll: GetItemsResponse<ListFieldsKeys> = yield call(
            getItemsRequest,
            { ...payload, nextPage } // Передавай текущую страницу для загрузки данных
          );

          // Добавь текущие элементы к общему массиву
          allItems = [...allItems, ...resultAll.items];

          // Обнови `nextPage` из ответа, если он существует
          nextPage = resultAll.nextPage;
        }

        // Если `all` не установлен, выходим после первой загрузки
        if (!all) break;
      } while (nextPage); // Повторяй, пока существует следующая страница

      // Отправь все загруженные элементы в store после завершения всех запросов
      yield put(
        getItemSuccess({
          items: allItems,
          listName: payload.listName,
        })
      );
    } else {
      result = yield call(getItemsRequest, payload);
    }

    yield put(
      getItemSuccess({
        ...result,
        listName: payload.listName,
      })
    );
    // @ts-ignore
    if (result.items.length > 0 && !payload.noUsersRequest) {
      let usersEmail: any = [];
      // @ts-ignore
      result.items.forEach((item: any) => {
        Object.keys(item).forEach((key) => {
          const field = item[key];
          if (field && !Array.isArray(field) && field.get_email) {
            if (field.get_email()) {
              usersEmail = [...usersEmail, field.get_email().toLowerCase()];
            }
          }
          if (
            field &&
            Array.isArray(field) &&
            field.length > 0 &&
            field[0].get_email
          ) {
            field.forEach((user) => {
              if (user.get_email()) {
                usersEmail = [...usersEmail, user.get_email().toLowerCase()];
              }
            });
          }
          if (
            (key === "AuthorEmail" ||
              key === "ResponsibleForRevisionEmail" ||
              key === "ResponsibleEmail") &&
            field &&
            (field.indexOf("@abinbevefes.com") !== -1 ||
              field.indexOf("@partnerabie.com") !== -1)
          ) {
            usersEmail = [...usersEmail, field.trim().toLowerCase()];
          }
        });
      });
      usersEmail = _.uniqWith(usersEmail, _.isEqual);
      if (usersEmail.length > 0) {
        yield put(addUsers(usersEmail));
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export function* addSaga<K extends ListFieldsKeys>(
  action: PayloadAction<AddItemRequestProps<K>>
) {
  try {
    const payload = action.payload;
    const { updateReducer } = payload;

    if (Object.keys(payload.body).length > 0) {
      const id: number = yield call(addDefaultSaga, payload);
      yield put(addItemSuccess({ ID: id, listName: payload.listName }));

      if (updateReducer) {
        const dataAdd: { items: ListFieldsType[ListFieldsKeys] } = yield call(
          getItemsRequest,
          {
            listName: payload.listName,
            filters: { ID: id },
          }
        );
        yield put(
          getItemsSuccess({
            listName: payload.listName,
            items: dataAdd.items,
            start: true,
            merge: true,
          })
        );
      }
      return id;
    } else {
      yield put(addItemSuccess({ ID: null, listName: payload.listName }));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* updateSaga<K extends ListFieldsKeys>(
  action: PayloadAction<UpdateItemRequestProps<K>>
) {
  try {
    const payload = action.payload;

    if (payload.updateStatus) {
      yield put(updateItemSuccess({ ID: null, listName: payload.listName }));
    } else {
      const id: number[] = yield call(updateDefaultSaga, payload);

      yield put(updateItemSuccess({ ID: id[0], listName: payload.listName }));

      if (typeof payload.update === "undefined" || payload.update) {
        yield put(getItemsIdle({ listName: payload.listName }));
        yield put(getItemIdle({ listName: payload.listName }));

        const dataAdd: { items: ListFieldsType[typeof payload.listName][] } =
          yield call(getItemsRequest, {
            listName: payload.listName,
            filters: { ID: id },
          });

        yield put(
          getItemsSuccess({
            listName: payload.listName,
            items: dataAdd.items,
            update: true,
          })
        );

        if (id.length === 1) {
          const result: { items: ListFieldsType[typeof payload.listName][] } =
            yield call(getItemsRequest, {
              listName: payload.listName,
              filters: { ID: id[0] },
            });

          yield put(
            getItemSuccess({
              ...result,
              listName: payload.listName,
            })
          );
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export function* deleteSaga<K extends ListFieldsKeys>(
  action: PayloadAction<DeleteItemRequestProps<K>>
) {
  try {
    const payload = action.payload;
    const { updateReducer } = action.payload;
    const id: number[] = yield call(deleteDefaultSaga, payload);

    yield put(deleteItemSuccess({ ID: id[0], listName: payload.listName }));

    if (updateReducer) {
      yield put(
        getItemsSuccess({
          listName: payload.listName,
          items: id.map((item: number) => {
            return { ID: item };
          }),
          delete: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* itemsWatcher() {
  yield takeEvery(getItems.toString(), getSaga);
  yield takeEvery(addItem.toString(), addSaga);
  yield takeEvery(updateItem.toString(), updateSaga);
  yield takeEvery(deleteItem.toString(), deleteSaga);
  yield takeEvery(getItem.toString(), itemSaga);
}
